<template>
  <div id="contenedor-vista-previa-pdf">
    <object
      :data="rutaArchivo"
      type="application/pdf"
      :height="height"
      :width="width">
      <!-- <param name="view" value="AAAAAAA"> -->
    </object>
  </div>
</template>

<script>
export default {
  name: 'VistaPreviaPdf',
  props: {
    rutaArchivo: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: '650px',
    },
    width: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>
